/*@ngInject*/
const ScoringRulesEditorHeaderController = function ($rootScope, $scope, $element, $stateParams, $state, loadingBarHandler, coreConstant, localization, scoringRulesEditorModel, configurationMediator, scoringRuleActions, scoringRuleActionsUtil, modalUtil, configurationActionsUtil, configurationConstant) {

    $element.addClass('scoringRulesEditorHeader');

    this.scoringRule = null;
    this.translations = null;

    this.actions = [];
    this.context = {
        identifier: 'scoringRulesEditorHeader',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.actionSubTexts = {};

    this.$onInit = function () {
        localization.getTranslationByKey('scoringRulesEditorHeader').then((translations) => {
            this.scoringRule = scoringRulesEditorModel.getScoringRule(_.isEmpty($stateParams.scoringRuleId) ? -1 : $stateParams.scoringRuleId);
            this.translations = translations;
            this.loadActions();
        });
    };

    this.loadActions = function () {
        configurationMediator.loadScoringRulesActions($stateParams.scoringRuleId).then((actions) => {
            let allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: this.context.model.contextType
            });

            this.processActions(allActions);
        });
    };

    this.processActions = function (actions) {
        this.actions = actions;
        this.actionSubTexts = {};

        _.each(this.actions, (subAction) => {
            _.each(subAction.actions, (action) => {
                if (action.name === scoringRuleActions.SAVE) {
                    action.enabled = false;
                    if (scoringRulesEditorModel.hasUnsavedChanges(this.scoringRule.id)) {
                        this.actionSubTexts[action.name] = {
                            class: 'unsavedChanges',
                            text: _.get(this.translations, 'unsavedChanges')
                        };
                        if (scoringRulesEditorModel.isValid(parseInt(this.scoringRule.id))) {
                            action.enabled = true;
                        }
                    }
                }
                if (action.name === scoringRuleActions.CREATE) {
                    action.enabled = false;
                    if (scoringRulesEditorModel.hasUnsavedChanges(this.scoringRule.id)) {
                        this.actionSubTexts[action.name] = {
                            class: 'unsavedChanges',
                            text: _.get(this.translations, 'unsavedChanges')
                        };
                        if (scoringRulesEditorModel.isValid(parseInt(this.scoringRule.id))) {
                            action.enabled = true;
                        }
                    }
                }
                if (action.name === scoringRuleActions.DISCARD) {
                    action.enabled = scoringRulesEditorModel.hasUnsavedChanges(this.scoringRule.id) || this.scoringRule.id === '-1';
                }
                if (action.name === scoringRuleActions.COPY) {
                    action.enabled = !scoringRulesEditorModel.hasUnsavedChanges(this.scoringRule.id) && this.scoringRule.id !== '-1';
                    if (action.enabled === false) {
                        action.notes = 'Copy is not available since there are unsaved changes';
                    }
                }
            });
        });

        this.actionsTimeLastModified = new Date().getTime();
    };

    this.handleAction = function (action) {
        if (action.enabled) {
            switch (action.name) {
                case scoringRuleActions.SAVE:
                    scoringRuleActionsUtil.save(this.translations, this.scoringRule);
                    break;

                case scoringRuleActions.CREATE:
                    scoringRuleActionsUtil.save(this.translations, this.scoringRule);
                    break;

                case scoringRuleActions.DISCARD:
                    scoringRuleActionsUtil.discard(this.translations);
                    break;

                case scoringRuleActions.DELETE:
                    scoringRuleActionsUtil.delete(this.translations, this.scoringRule.id);
                    break;

                case scoringRuleActions.COPY:
                    let name = (_.get(this.translations, 'copyOf')) + this.scoringRule.name,
                        copiedScoringRule = _.clone(this.scoringRule);
                    copiedScoringRule.name = name;
                    scoringRuleActionsUtil.copy(this.translations, copiedScoringRule);
                    break;

                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    $scope.$on(configurationConstant.event.SCORING_RULE_UPDATED, (event, scoringRuleId) => {
        this.scoringRule = scoringRulesEditorModel.getScoringRule(scoringRuleId);
        this.processActions(this.actions);
    });

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        const isCurrentStateScoringRuleEditor = _.startsWith(fromState.name, 'configuration.manageScoringRules'),
            isTargetSameAsCurrent = toState.name === fromState.name,
            scoringRuleId = this.scoringRule.id,
            hasUnsavedChanges = scoringRulesEditorModel.hasUnsavedChanges(scoringRuleId),
            isValid = scoringRulesEditorModel.isValid(scoringRuleId);

        if (toState.name === 'login') {
            return;
        }

        if (hasUnsavedChanges && isCurrentStateScoringRuleEditor && !isTargetSameAsCurrent) {
            event.preventDefault();
            if (isValid) {
                loadingBarHandler.showNotificationLoadingBar(_.get(this.translations, 'saveScoringRule.loadingBar'));
                if (this.scoringRule.id === -1) {
                    this.scoringRule.id = null;
                }
                configurationMediator.saveScoringRule(this.scoringRule).then(() => {
                    scoringRulesEditorModel.setUnsavedChanges(scoringRuleId, false);
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(this.translations, 'saveScoringRule.savingScoringRuleSuccessLoadingBar'));
                    $state.go(toState, toParams);
                });
            } else {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'invalidScoringRules'));
            }
        }
    });

    this.openGenericConfirm = function (title, summary, confirmActionButtonLabel) {
        modalUtil.showGenericConfirm({
            title: title,
            summary: summary,
            confirmActionButtonLabel: confirmActionButtonLabel
        });
    };
};

angular.module('ums.configuration')
    .controller('scoringRulesEditorHeaderController', ScoringRulesEditorHeaderController);
